import React from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardImg,
  CardText,
  CardImgOverlay
} from 'reactstrap';

import { projects } from './projectsData';

const Projects = props => {
  return (
    <Container className='py-5'>
      <h3 className='text-center mb-5'>Projects</h3>
      <Row>
        {projects.map((project, index) => (
          <Col lg={3} md={3} sm={12} key={index} className='mb-3'>
            <Card>
              <CardImg src={project.image}></CardImg>
              <CardImgOverlay>
                <div className='d-flex flex-column align-items-center justify-content-end'>
                  <p className='lead bg-primary text-white'>{project.title}</p>
                  <a
                    className='btn btn-sm btn-primary text-white'
                    href={`http://${project.url}`}
                    target='_blank'
                    rel='noopener noreferrer'>
                    Visit Site
                  </a>
                </div>
              </CardImgOverlay>
              <CardBody>
                {project.techs.map((tech, index) => (
                  <CardText className='text-center' key={index}>
                    {tech}
                  </CardText>
                ))}
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Projects;
